export const SETTINGS_ENUM = Object.freeze({
  ALLOW_APPLICATION_IDS: 'ALLOW_APPLICATION_IDS',
  CBR_ENABLED: 'CBR_ENABLED',
  PRACTICE_ENABLED: 'PRACTICE_ENABLED',
  READING_ENABLED: 'READING_ENABLED',
  REGISTRATION_ENABLED: 'REGISTRATION_ENABLED',
  VIDEO_ENCODING_ENABLED: 'VIDEO_ENCODING_ENABLED',
});
